/**
 * 生产安全 · 设备总览（/safety-flow）字段模型
 * 后台按区块分组展示可编辑字段（中文 label + 类型 + 默认值），前端用 $C/$CList 读取。
 * 设备列表与提示文字默认值来自 src/data/productionSafety.js，统计条默认值内联，
 * 与页面当前内置内容保持一致，未配置时页面外观不变。
 */
import { SAFETY_DEVICES, SAFETY_TIP } from '@/data/productionSafety'

// 底部统计条（与页面 data() 中当前硬编码值一致）
const SAFETY_STATS = [
  { label: '核心设备', value: 10, unit: '台', color: '#31FFFF' },
  { label: '今日开机', value: 10, unit: '台', color: '#31E58B' },
  { label: '安全运行', value: 126, unit: '天', color: '#FFC857' },
  { label: '今日批次', value: 12, unit: '批', color: '#eaf3ff' },
  { label: '报警事件', value: 0, unit: '起', color: '#FF7A6B' },
]

export default {
  title: '生产安全 · 设备总览',
  groups: [
    {
      title: '页头区域',
      fields: [
        { key: 'bannerText', label: '页面主标题', type: 'text', default: '酪蛋白生产安全流程' },
        { key: 'backFromChain', label: '返回按钮（产业链来源）', type: 'text', default: '返回产业链' },
        { key: 'backDefault', label: '返回按钮（默认）', type: 'text', default: '返回' },
      ],
    },
    {
      title: '设备流程面板',
      fields: [
        { key: 'devices', label: '核心设备列表', type: 'array', default: SAFETY_DEVICES },
        { key: 'tip', label: '底部提示文字', type: 'textarea', default: SAFETY_TIP },
      ],
    },
    {
      title: '底部统计条',
      fields: [
        { key: 'stats', label: '统计指标', type: 'array', default: SAFETY_STATS },
      ],
    },
    {
      title: '图片与视频',
      fields: [
        { key: 'pageBg', label: '页面背景图（覆盖默认渐变）', type: 'image', default: '' },
      ],
    },
  ],
}
